import { useTranslation } from 'react-i18next';
import NavigationHeader from 'components/molecules/navigation-header';

import type { FC } from 'react';

const UntrackedInboundCallsHeader: FC = () => {
  const { t } = useTranslation();
  return <NavigationHeader title={t('labels.callHistoryManagement')} />;
};

export default UntrackedInboundCallsHeader;
